export default __webpack_public_path__ + "images/00ff848bbbd9715e56f3f3af397e5652.png";